<template>
    <div class="tw:flex tw:flex-col tw:sm:flex-row tw:sm:flex-wrap tw:gap-3 tw:sm:gap-2 tw:sm:items-center">
        <div class="tw:w-full tw:sm:w-56">
            <SearchComponent
                :value="local.search"
                :disabled="loading"
                @input="val => onFilterChange('search', val)"
            />
        </div>

        <div class="tw:w-full tw:sm:w-48">
            <BaseMultiselect
                name="estado"
                label="Estado"
                :options="estadoOptions"
                value-key="id"
                label-key="label"
                :value="local.estado"
                :disabled="loading"
                @input="val => onFilterChange('estado', val !== '' && val !== null && val !== undefined ? val : '')"
            />
        </div>

        <div v-if="context === 'bases'" class="tw:w-full tw:sm:w-64">
            <BaseMultiselect
                name="equipo"
                label="Equipo"
                :options="equipos"
                value-key="id"
                label-key="nombre"
                :value="local.equipo"
                :disabled="loading"
                :multiple="true"
                @input="val => onFilterChange('equipo', Array.isArray(val) ? val : [])"
            />
        </div>

        <div class="tw:w-full tw:sm:w-40">
            <BaseDateInput
                name="fecha_desde"
                label="Fecha desde"
                :value="local.fecha_desde"
                :disabled="loading"
                @input="val => onFilterChange('fecha_desde', val)"
            />
        </div>

        <div class="tw:w-full tw:sm:w-40">
            <BaseDateInput
                name="fecha_hasta"
                label="Fecha hasta"
                :value="local.fecha_hasta"
                :disabled="loading"
                :min="local.fecha_desde"
                @input="val => onFilterChange('fecha_hasta', val)"
            />
        </div>

        <Button
            :disabled="loading"
            variant="ghost"
            custom-class="tw:w-full tw:sm:w-auto"
            @click="resetFilters"
        >
            Limpiar filtros
        </Button>
    </div>
</template>

<script setup>
    import { reactive, watch } from 'vue';
    import SearchComponent from '@/modules/admin/ui/SearchComponent.vue';
    import BaseMultiselect from '@/modules/admin/ui/BaseMultiselect.vue';
    import BaseDateInput from '@/modules/admin/ui/BaseDateInput.vue';
    import Button from '@/modules/admin/ui/Button.vue';

    const props = defineProps({
        filters: {
            type: Object,
            required: true
        },
        context: {
            type: String,
            default: 'abonos',
            validator: value => ['abonos', 'bases'].includes(value)
        },
        equipos: {
            type: Array,
            default: () => []
        },
        updateFilter: {
            type: Function,
            default: null
        },
        loading: {
            type: Boolean,
            default: false
        }
    });

    const emit = defineEmits(['update:filter', 'reset']);

    const local = reactive({
        search: '',
        estado: '',
        equipo: [],
        fecha_desde: '',
        fecha_hasta: ''
    });

    const estadoOptions = [
        { id: 0, label: 'Pendiente' },
        { id: 1, label: 'Pagado' },
        { id: 2, label: 'Anulado' },
        { id: 3, label: 'Fallido' },
        { id: 4, label: 'Fallido Definitivo' },
        { id: 5, label: 'Bloqueado' }
    ];

    let syncingFromProps = false;

    watch(
        () => props.filters,
        newVal => {
            if (!newVal) return;
            syncingFromProps = true;
            Object.assign(local, {
                search: newVal.search ?? '',
                estado: newVal.estado ?? '',
                equipo: Array.isArray(newVal.equipo) ? [...newVal.equipo] : [],
                fecha_desde: newVal.fecha_desde ?? '',
                fecha_hasta: newVal.fecha_hasta ?? ''
            });
            syncingFromProps = false;
        },
        { immediate: true, deep: true }
    );

    function onFilterChange(key, value) {
        local[key] = value;
        if (!syncingFromProps) {
            if (props.updateFilter) {
                props.updateFilter(key, value);
            } else {
                emit('update:filter', { key, value });
            }
        }
    }

    function resetFilters() {
        local.search = '';
        local.estado = '';
        local.equipo = [];
        local.fecha_desde = '';
        local.fecha_hasta = '';

        if (props.updateFilter) {
            props.updateFilter('search', '');
            props.updateFilter('estado', '');
            props.updateFilter('equipo', []);
            props.updateFilter('fecha_desde', '');
            props.updateFilter('fecha_hasta', '');
        } else {
            emit('reset');
        }
    }
</script>
